import FormControl from '@nib-components/form-control';
import { errorMessage, isValid, isTouched, isFieldOptionalAndEmpty } from '../../util/validationHelpers';
import { FUNNELS, getFormControlType } from '../../util/constants';
import { combineHandlerWithFormik } from '../../util/eventHelpers';
import { defaultFieldPropTypes } from '../../types';
import React from 'react';
const BaseFormField = props => {
  const {
    funnel = FUNNELS.ARHI,
    label = '',
    help = '',
    width = 20,
    optional = false,
    disabled,
    fullstory = 'mask',
    name,
    id,
    input,
    field,
    info,
    children,
    onBlur,
    onChange,
    maxLength,
    inline,
    required,
    ...otherProps
  } = props;
  // if field is optional we don't want to show the green tick and underline (green box-shadow) when empty.
  let isEmptyAndOptional = optional;
  // name is moved to field.name for formik, input.name for redux-form
  const isFormik = Boolean(field);
  const isReduxForm = Boolean(input);
  // eslint-disable-next-line no-nested-ternary
  let inputName = name;
  let handleBlur = onBlur;
  let handleChange = onChange;
  if (isFormik) {
    handleBlur = combineHandlerWithFormik(field === null || field === void 0 ? void 0 : field.onBlur, onBlur);
    handleChange = combineHandlerWithFormik(field === null || field === void 0 ? void 0 : field.onChange, onChange);
    inputName = field === null || field === void 0 ? void 0 : field.name;
    isEmptyAndOptional = isFieldOptionalAndEmpty(optional, field);
  } else if (isReduxForm) {
    // Redux-Form _helpfully_ sets the value of the field onBlur (even if a user is just tabbing through the form and not actively selecting an option)
    // todo: 99% sure the old code was wrong eg setting the handler to a result of a redux handler eg 'handleBlur = input.onBlur(undefined, true)'
    // This replacement code is whats been done in all other base components
    handleBlur = () => (input === null || input === void 0 ? void 0 : input.onBlur) ? input.onBlur(undefined, true) : (e, value) => {};
    // do we even need the handle change here? We seem to be moving away from redux form anyway
    handleChange = input === null || input === void 0 ? void 0 : input.onChange;
    inputName = input === null || input === void 0 ? void 0 : input.name;
  }
  const validState = isValid({
    ...otherProps,
    id
  });
  const validatedState = isTouched({
    ...otherProps,
    id
  });
  const errorState = errorMessage({
    ...otherProps,
    id
  });
  /*
    firstName test blows up if `mask` gets passed down in otherProps to the child element
    We need other props for formMode to work.
  */
  // eslint-disable-next-line no-unused-vars
  const {
    mask,
    ...otherPropsWithoutMask
  } = otherProps;
  return React.createElement(FormControl, {
    name: inputName,
    id: id,
    label: label,
    help: help,
    valid: validState,
    validated: validatedState,
    isEmptyAndOptional: isEmptyAndOptional,
    error: errorState,
    info: info,
    width: width,
    maxLength: maxLength,
    fullstory: fullstory,
    disabled: disabled,
    inline: inline,
    formControlType: getFormControlType(required, optional)
  }, children && React.cloneElement(children, {
    ...field,
    ...input,
    onBlur: handleBlur,
    onChange: handleChange,
    isEmptyAndOptional,
    ...otherPropsWithoutMask
  }));
};
BaseFormField.defaultProps = defaultFieldPropTypes;
export default BaseFormField;